module.exports = __webpack_public_path__ + "img/pr-book.cc18fbb8.png";